import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {FontAwesomeService} from '@services/font-awesome.service';
import {SHIPMENTS_LOAD} from '@store/actions';
import {forkJoin} from 'rxjs/observable/forkJoin';
import {Store} from '@ngrx/store';
import {AccountService} from '@services/account.service';
import {AppState, selectBookedShipments} from '@store/reducers';
import {Subscription} from 'rxjs/Subscription';
import {ActivatedRoute} from '@angular/router';
import {ShipmentHistory} from '@models/shipment-history.interface';
import {ShipmentStatus} from '@models/shipment-status.enum';
import {ShipmentStatusService} from '@services/shipment-status.service';

@Component({
  selector: 'app-shipment-status',
  templateUrl: './shipment-status.component.html',
  styleUrls: ['./shipment-status.component.scss']
})
export class ShipmentStatusComponent implements OnInit , OnChanges {
  @Input() shipment: any;
  subscription: Subscription;
  id: number;
  sourceShipments: any[];
  pageSize = 3;
  rows = [
    {label: 'Consignment no', value: 'consignment_no'},
    {label: 'Consignor', value: 'consignor'},
    {label: 'Consignee', value: 'consignee'},
    {label: 'Status', value: 'status'},
    {label: 'Price', value: 'price'},
  ];
  constructor(
    public faService: FontAwesomeService,
    private activateRoute: ActivatedRoute,
    private accountService: AccountService,
    public shipmentStatusService: ShipmentStatusService,
    private store: Store<AppState>
  ) {}
  ngOnInit() {
    // this.subscription = this.activateRoute.params.subscribe((params) => {
    //     this.id = params['id'];
    //     this.getShipment(this.id);
    // });



    // this.store.select(selectBookedShipments)
    //   .subscribe(shipments => {
    //     this.sourceShipments = shipments && this.generateData(shipments);
    //     this.handleChangeDisplayedShipments();
    //     if (!shipments) {
    //       forkJoin([
    //         this.accountService.getShipments('CREATED'),
    //         this.accountService.getShipments('STORED'),
    //       ])
    //         .subscribe(([created, stored]) => {
    //           const shipments = {
    //             booked: [...created.data, ...stored.data],
    //           };
    //           this.store.dispatch({
    //             type: SHIPMENTS_LOAD,
    //             payload: shipments,
    //           })
    //         })
    //     }
    //   });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.shipment) {
      this.shipment = changes.shipment.currentValue;
    }
  }

  getShipment(id) {
    this.accountService.getShipment(id).subscribe((data) => {
      this.shipment = data;
    });
  }

  applyFilter(data) {
  }
  getColorByIndex(statusIndex: number) {
    let status: ShipmentStatus;
    switch (statusIndex) {
      case 0: status = ShipmentStatus.CREATED; break;
      case 1: status = ShipmentStatus.CONFIRMED; break;
      case 2: status = ShipmentStatus.PICKUP; break;
      case 3: status = ShipmentStatus.DELIVERED; break;
      case 4: status = ShipmentStatus.FAILED; break;
    }
    return this.shipmentStatusService.getColorByStatus(ShipmentStatus[status]);
  }

  getColorByStatusName(status: string) {
    return this.shipmentStatusService.getColorByStatus(ShipmentStatus[status]);
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/shipments/components/shipment-status/shipment-status.component.ts